<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="modal_title">Rename Item</div>
        <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="renameItemForm">
        <!-- Item Name-->
        <mat-form-field>
            <mat-label>Name</mat-label>
            <!-- Set the placeholder value to item.name -->
            <input matInput [formControlName]="'itemName'" [placeholder]=setPlaceholder() [value]="'Untitled Folder'"
                [(ngModel)]="data.name" maxlength="400" (keydown.enter)="saveAndClose()">
            <mat-error *ngIf="renameItemForm.get('itemName').hasError('required')">
                Folder name is required
            </mat-error>
        </mat-form-field>

        <mat-label>Description</mat-label>
        <textarea [formControlName]="'description'" [(ngModel)]="folder.description" id="description" rows="4"
            class="block p-2.5 w-full text-sm mb-3 text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="description ..."></textarea>
       
        <div class="flex justify-end mt-5 sm:mt-0">
            <!-- Cancel -->
            <button class="ml-auto sm:ml-0 mr-2" mat-stroked-button (click)="cancel()">
                Cancel
            </button>

            <!-- Save -->

            <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="saveAndClose()"
                [disabled]="renameItemForm.disabled">
                <span *ngIf="!renameItemForm.disabled">
                    Save
                </span>
                <mat-progress-spinner *ngIf="renameItemForm.disabled" [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>
        </div>

    </form>
</div>